import { categories } from "@/mocks/works";
import SectionHeading from "./SectionHeading";

export default function Categories() {
  return (
    <section id="categories" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="题材分类"
          title="按你喜欢的氛围，快速找到同类作品"
          desc="从婚后恋爱的甜蜜到家庭日常的治愈，我们把作品按情感氛围精细分类，让你第一时间定位心仪题材。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <a
              key={c.id}
              href={`#recommend`}
              className="group relative flex flex-col overflow-hidden rounded-2xl bg-background-100 ring-1 ring-background-200/80 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-40 w-full overflow-hidden md:h-44">
                <img
                  src={c.image}
                  alt={`${c.name}分类封面`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/30 to-transparent"></div>
                <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-foreground-700">
                  {c.count} 部
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-900">{c.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
                  去发现
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}